
// Cart Drawer qty change Started -----------------
var MIN_QTY = 4;
var MATCH_TEXT = '/ custom /';
var isApplyingLogic = false;
var lastWasAllColors = null;
var lastWasCustom = null;

function enforceMinQtyForCustomItems() {
  var cartItems = document.querySelectorAll('li.rebuy-cart__flyout-item');
  console.log('cartItems:', cartItems);
  cartItems.forEach(item => {
    var titleEl = item.querySelector('.rebuy-cart__flyout-item-variant-title');
    var qtyLabel = item.querySelector('.rebuy-cart__flyout-item-quantity-widget-label');
    var minusBtn = item.querySelector('.rebuy-cart__flyout-item-quantity-widget-button:first-of-type');
    var plusBtn = item.querySelector('.rebuy-cart__flyout-item-quantity-widget-button:last-of-type');

    if (!titleEl || !qtyLabel) return;

    var isCustom = titleEl.textContent.toLowerCase().includes(MATCH_TEXT);

    if (!isCustom) return;

    // Extract numeric quantity
    var qty = parseInt(qtyLabel.textContent.replace(/\D/g, ''), 10) || 1;
    console.log(qty);
    // Enforce minimum
    if (qty < MIN_QTY) {
      qty = MIN_QTY;
      qtyLabel.textContent = qty;
    }

    // Update minus button state
    if (minusBtn) {
      minusBtn.disabled = qty <= MIN_QTY;
      minusBtn.style.opacity = qty <= MIN_QTY ? '0.4' : '';
    }

    // Update plus button state (optional, just reset style if needed)
    if (plusBtn) plusBtn.style.opacity = '';

    // Observe quantity changes (clicks or manual edits)
    var observer = new MutationObserver(() => {
      var newQty = parseInt(qtyLabel.textContent.replace(/\D/g, ''), 10) || 1;

      if (newQty < MIN_QTY) {
        qtyLabel.textContent = MIN_QTY;
        newQty = MIN_QTY;
      }

      if (minusBtn) {
        minusBtn.disabled = newQty <= MIN_QTY;
        minusBtn.style.opacity = newQty <= MIN_QTY ? '0.4' : '';
      }
    });

    observer.observe(qtyLabel, { characterData: true, subtree: true, childList: true });
  });
}

// Initial run
setTimeout(enforceMinQtyForCustomItems, 500);

// Observe cart drawer changes (AJAX updates)
var cartDrawer = document.querySelector('.rebuy-cart__flyout');
if (cartDrawer) {
  var drawerObserver = new MutationObserver(() => {
    enforceMinQtyForCustomItems();
  });

  drawerObserver.observe(cartDrawer, { childList: true, subtree: true });
}
// Cart Drawer qty change Ended -----------------

/*********************************
 * ELEMENT SELECTORS
 *********************************/

var variantInput = document.querySelector('[name="id"]');
var variantInputParentBlock = document.querySelector('safe-sticky.product-info');

var qtyButtons = document.querySelectorAll('.quantity-selector__button');
var qtyDecrease = qtyButtons[0];
var qtyIncrease = qtyButtons[1];

var infiniteOptionsLoaded = false;
var infiniteOptionsHiddenOnce = false;
/*********************************
 * HELPER FUNCTIONS
 *********************************/
function isCustomSelected() {
  var checkedBrand = document.querySelector('.variant-picker__option input[type="radio"][data-option-position="3"]:checked');
  if (!checkedBrand) return false;

  var labelSpan = document.querySelector(`label[for="${checkedBrand.id}"] span`);
  return labelSpan?.textContent.trim().toLowerCase() === 'custom';
}

function getQty() {
  var quantityInput = document.querySelector('.quantity-selector__input[name="quantity"]');
  return parseInt(quantityInput?.value, 10) || 1;
}

function setQty(val) {
  var quantityInput = document.querySelector('.quantity-selector__input[name="quantity"]');
  if (!quantityInput) return;

  quantityInput.value = val;
  quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
  quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
}

function updateDecreaseButtonState() {
  var currentQty = getQty();
  var isCustom = isCustomSelected();
  var isAllColors = isColorAllWheel();

  var qtyDecrease = document.querySelector('.quantity-selector__button:first-of-type');
  if (!qtyDecrease) return;

  let shouldDisable = false;

  if (!isCustom && currentQty <= 1) shouldDisable = true;
  if (isCustom && !isAllColors && currentQty <= 4) shouldDisable = true;

  qtyDecrease.disabled = shouldDisable;
  qtyDecrease.style.opacity = shouldDisable ? '0.4' : '';
  qtyDecrease.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');
}

function isColorAllWheel() {
  const checkedColor = document.querySelector('input[data-option-position="2"]:checked');
  if (!checkedColor) return false;

  const label = document.querySelector(`label[for="${checkedColor.id}"] .sr-only`);
  const text = label?.textContent.trim().toLowerCase();

  return text?.includes('all 15 colors');
}

// MAIN CUSTOM LOGIC
function applyCustomLogic() {
  if (isApplyingLogic) return;
  isApplyingLogic = true;
  updateNotesField();

  var isCustom = isCustomSelected();
  var isAllColors = isColorAllWheel(); // ✅ YOU WERE MISSING THIS
  var customBlock = document.querySelector('[data-block-type="@app"] #infiniteoptions-container');

  if (customBlock) {
    customBlock.style.display = isCustom ? 'block' : 'none';
  }

  var currentQty = getQty();
  /* -------- RULE 2 & 4 -------- */
  // If we JUST switched from custom → non-custom, reset to 1
  if (!isCustom && lastWasCustom === true) {
    setQty(1);
  }

  /* -------- RULE 1 -------- */
  // Custom + All Colors → if coming from normal color OR non-custom AND qty was 4 → make 1
  else if (isCustom && isAllColors) {
    if ((lastWasAllColors === false || lastWasCustom === false) && currentQty === 4) {
      setQty(1);
    }
  }

  /* -------- RULE 3 -------- */
  // Custom + Normal Colors → minimum 4
  else if (isCustom && !isAllColors) {
    if (currentQty < 4) setQty(4);
  }

  /* -------- SAVE STATE -------- */
  lastWasAllColors = isAllColors;
  lastWasCustom = isCustom;

  updateDecreaseButtonState();
  syncInfiniteOptionsProperties();

  setTimeout(() => { isApplyingLogic = false; }, 50);
}

function disablePropertyInput(input) {
  input.dataset.originalName ||= input.name; // store once
  input.removeAttribute('required');
  input.removeAttribute('name');
  input.disabled = true;
}
function setCustomMode(isCustom) {
  propertyInputs.forEach(input => {
    if (isCustom) {
      enablePropertyInput(input);
    } else {
      disablePropertyInput(input);
    }
  });
}
function syncInfiniteOptionsProperties() {
  const isCustom = isCustomSelected();
  const inputs = document.querySelectorAll('#infiniteoptions-container input');

  inputs.forEach(input => {
    // --- CUSTOM SELECTED ---
    if (isCustom) {
      // Restore name from all possible sources
      if (!input.name) {
        if (input.dataset.originalName) {
          input.name = input.dataset.originalName;
          console.log('custom-if: ', input.name);
        } else if (input.getAttribute('name-disabled')) {
          input.name = input.getAttribute('name-disabled');
          console.log('custom-else: ', input.name);
        }
      }
      input.disabled = false;
      input.removeAttribute('aria-disabled');
    }

    // --- NON CUSTOM ---
    else {
      // Store name safely
      if (input.name && !input.dataset.originalName) {
        input.dataset.originalName = input.name;
        console.log('non-custom-if: ', input.name);
      }

      input.removeAttribute('name');
      input.disabled = true;
      input.setAttribute('aria-disabled', 'true');
    }
  });
}

function bindOptionListeners() {
  // Quantity input
  var qtyInput = document.querySelector('.quantity-selector__input[name="quantity"]');
  if (qtyInput && !qtyInput.dataset.boundLogic) {
    qtyInput.addEventListener('change', () => {
      applyCustomLogic();
    });
    qtyInput.dataset.boundLogic = 'true';
  }

  // Style (Custom) radios
  document.querySelectorAll('input[data-option-position="3"]').forEach(radio => {
    if (!radio.dataset.boundLogic) {
      radio.addEventListener('change', () => {
        applyCustomLogic();
        updateNotesField();
      });
      radio.dataset.boundLogic = 'true';
    }
  });

  // Color radios
  document.querySelectorAll('input[data-option-position="2"]').forEach(radio => {
    if (!radio.dataset.boundLogic) {
      radio.addEventListener('change', () => {
        applyCustomLogic();
      });
      radio.dataset.boundLogic = 'true';
    }
  });

  // Prevent invalid decrease before it happens
  var decreaseBtn = document.querySelector('.quantity-selector__button[name="minus"], .quantity-selector__button:first-of-type');

  if (decreaseBtn && !decreaseBtn.dataset.boundLogic) {
    decreaseBtn.addEventListener('click', function(e) {
      var isCustom = isCustomSelected();
      var qty = getQty();

      // Custom + NOT All Colors → cannot go below 4
      if (isCustom && !isColorAllWheel() && qty <= 4) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    decreaseBtn.dataset.boundLogic = 'true';
  }
}

function createNotesField() {
  if (document.getElementById('custom-notes-field')) return;

  var variantPickerBlock = document.querySelector('[data-block-type="variant-picker"]');
  if (!variantPickerBlock) return;

  var wrapper = document.createElement('div');
  wrapper.id = 'custom-notes-field';
  wrapper.style.marginTop = '15px';

  wrapper.innerHTML = `
    <label for="product-notes" style="display:block; font-weight:600; margin-bottom:6px;">
      Notes / Image Link
    </label>
    <input 
      type="text" 
      id="product-notes" 
      placeholder="Please use this to further customize your order or simply to say hi!"
      style="width:100%; padding:10px; border:1px solid #ccc; border-radius:6px;"
    />
  `;

  variantPickerBlock.insertAdjacentElement('afterend', wrapper);
}

function updateNotesField() {
  var wrapper = document.getElementById('custom-notes-field');
  var input = document.getElementById('product-notes');
  if (!wrapper || !input) return;

  if (isCustomSelected()) {
    wrapper.style.display = 'none';          // Hide block
    input.removeAttribute('name');           // remove line item property
  } else {
    wrapper.style.display = 'block';         // Show block
    input.name = 'properties[Notes]';        // restore property
  }
}

/********************
 * EVENT BINDINGS
 ********************/
// Qty change event
// document.querySelector('.quantity-selector__input[name="quantity"]')?.addEventListener('change', applyCustomLogic);

// Brand selection change OR Color change
// var brandRadios = document.querySelectorAll('.variant-picker__option input[type="radio"][data-option-position="3"], .variant-picker__option input[type="radio"][data-option-position="2"]' );
// brandRadios.forEach(radio => radio.addEventListener('change', applyCustomLogic));

// Observe hidden variant input for other changes
// if (variantInput && variantInputParentBlock) {
//   var variantObserver = new MutationObserver(() => {
//     document.querySelector('.quantity-selector__input[name="quantity"]')?.addEventListener('change', applyCustomLogic);
//     var brandRadios = document.querySelectorAll('.variant-picker__option input[type="radio"][data-option-position="3"], .variant-picker__option input[type="radio"][data-option-position="2"]' );
//     brandRadios.forEach(radio => radio.addEventListener('change', applyCustomLogic));

//     applyCustomLogic();
//   });
//   variantObserver.observe(variantInputParentBlock, { attributes: false, subtree: false, childList: true });
// }

if (variantInputParentBlock) {
  var variantObserver = new MutationObserver(() => {
    createNotesField();
    bindOptionListeners();
    applyCustomLogic();
  });

  variantObserver.observe(variantInputParentBlock, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', () => {
  createNotesField();
  bindOptionListeners();
  applyCustomLogic();
});



function observeInfiniteOptions() {
  if (infiniteOptionsLoaded) return;

  const containerSelector = '[data-block-type="@app"] #infiniteoptions-container';
  const ioInputLoadSelector = containerSelector + ' input[name^="properties"]';

  const observer = new MutationObserver(() => {
    const input = document.querySelector(ioInputLoadSelector);
    if (!input) return;

    infiniteOptionsLoaded = true;

    const container = document.querySelector(containerSelector);
    if (container) {
      const styleObserver = new MutationObserver((mutationsList) => {
        mutationsList.forEach(mutation => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            if (!infiniteOptionsHiddenOnce && container.style.display === 'block') {
              infiniteOptionsHiddenOnce = true;
              container.style.display = 'none';
              styleObserver.disconnect(); // run only once
            }
          }
        });
      });
      styleObserver.observe(container, {attributes: true, attributeFilter: ['style']});
      // Initial check (important)
      if ( !infiniteOptionsHiddenOnce && container.style.display === 'block' ) {
        infiniteOptionsHiddenOnce = true;
        container.style.display = 'none';
        styleObserver.disconnect();
      }
    }

    applyCustomLogic();
    observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
}
observeInfiniteOptions();

// Prevent the Cursor image change on clicking product main media image 
var el = document.querySelector('.product-gallery__media-list-wrapper');
el.style.pointerEvents = 'none';


// Crop the spaces up and bottom slightly for small images and making it little zoom - Only mobile screen
function cropMobileProductImages() {
    const isMobile = window.matchMedia("(max-width: 749px)").matches;

    document.querySelectorAll('.product-gallery__media[data-media-type="image"]').forEach(media => {
      const img = media.querySelector('img');
      if (!img) return;

      const srcData = ((img.getAttribute("src") || "") + " " + (img.getAttribute("srcset") || "")).toLowerCase();
      const isLargeImage = srcData.includes("large");

      // Reset everything first
      media.style.overflow = "";
      media.style.marginBottom = "";
      img.style.transform = "";
      img.style.transformOrigin = "";

      if (!isMobile || isLargeImage) return; // DO NOTHING to large images

      // Only SMALL images adjusted
      media.style.overflow = "hidden";
      media.style.marginBottom = "-6%";   // removes extra bottom space

      img.style.display = "block";
      img.style.width = "100%";
      img.style.height = "auto";
      img.style.transformOrigin = "center center";
      img.style.transform = "scale(1.10)";
    });
  }

  cropMobileProductImages(); 